import { WmChart, WmChartSlice } from "@watermarkinsights/ripple-react";
import { useIntl } from "react-intl";

function useFormatMessage(msgId: string): string {
  return useIntl().formatMessage({
    id: msgId
  });
}
interface Accomplishment {
  category: string;
  count: number;
  order: number;
}
interface AccomplishmentsProps {
  accomplishments: Accomplishment[];
  forHtml: boolean;
}

export const AccomplishmentsChart = ({
  accomplishments,
  forHtml
}: AccomplishmentsProps) => {
  const chartLabel = useFormatMessage(
    "app.faculty.accomplishmentbyScholarship"
  );
  const contracts = useFormatMessage("app.faculty.legends.contracts");
  const performanceExhibits = useFormatMessage(
    "app.faculty.legends.performanceExhibits"
  );
  const presentations = useFormatMessage("app.faculty.legends.presentations");
  const publications = useFormatMessage("app.faculty.legends.publications");
  const intellectualProperty = useFormatMessage(
    "app.faculty.legends.intellectualProperty"
  );

  const contractsPopoverText = useFormatMessage(
    "app.faculty.popover.contracts"
  );
  const performanceExhibitsPopoverText = useFormatMessage(
    "app.faculty.popover.performanceExhibits"
  );
  const presentationsPopoverText = useFormatMessage(
    "app.faculty.popover.presentations"
  );
  const publicationsPopoverText = useFormatMessage(
    "app.faculty.popover.publications"
  );
  const intellectualPropertyPopoverText = useFormatMessage(
    "app.faculty.popover.intellectualProperty"
  );

  const getLegendAndPopoverText = (category: string) => {
    switch (category) {
      case "CONGRANT":
        return [contracts, contractsPopoverText];
      case "PERFORM_EXHIBIT":
        return [performanceExhibits, performanceExhibitsPopoverText];
      case "PRESENT":
        return [presentations, presentationsPopoverText];
      case "INTELLCONT":
        return [publications, publicationsPopoverText];
      case "INTELLPROP":
        return [intellectualProperty, intellectualPropertyPopoverText];
      default:
        return [category, category];
    }
  };
  return (
    <WmChart
      chartType="bar5"
      label={forHtml ? " " : chartLabel}
      valueFormat="amount"
      key="scholarship-summary-chart"
      id="scholarship-summary-chart"
    >
      {accomplishments.map((acc: Accomplishment) => {
        const [legend, popoverText] = getLegendAndPopoverText(acc.category);
        return (
          <WmChartSlice
            amount={`${acc.count}`}
            legend={legend}
            popover-title={`${acc.count}`}
            popover-text={popoverText}
            key={acc.category}
          />
        );
      })}
    </WmChart>
  );
};
